import { createSlice } from "@reduxjs/toolkit";
import { rootCssSet } from "../../utils/helpers/common";

const initialState = {
  usersListReset: false,
  usersListFilter: false,
  actionDialogBoxData: {
    id: "",
    action: "",
    api_key: "",
    name: "",
    type: "",
  },
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUsersListReset: (state) => {
      state.usersListReset = !state.usersListReset;
    },

    setUsersListFilter: (state) => {
      state.usersListFilter = !state.usersListFilter;
      rootCssSet();
    },

    setActionDialogBoxData: (state, action) => {
      state.actionDialogBoxData = action?.payload;
    },
  },
});

export const userAction = userSlice.actions;
export const userReducer = userSlice.reducer;
